import { SurchargesKpisActionTypes } from './constants';

type SurchargesKpisAction = { type: string, payload: {} | string };

export const surchargesKpisApiResponseSuccess = (actionType: string, data: any): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const surchargesKpisApiResponseError = (actionType: string, error: string): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getNoSurcharges = (query): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.GET_TOTAL_NO_SURCHARGES,
    payload: { query },
});

export const getNoNonShipmentSurcharges = (query): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES,
    payload: { query },
});

export const getSurchargesCost = (query): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.GET_TOTAL_SURCHARGES_COST,
    payload: { query },
});

export const getNonShipmentSurchargesCost = (query): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST,
    payload: { query },
});

export const getSurchargeSummary = (query): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.GET_SURCHARGE_SUMMARY,
    payload: { query },
});

export const getNonShipmentSurchargeSummary = (query): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.GET_NON_SHIPMENT_SURCHARGE_SUMMARY,
    payload: { query },
});

export const getSurchargesByTimeframe = (query): SurchargesKpisAction => ({
    type: SurchargesKpisActionTypes.GET_SURCHARGES_BY_TIMEFRAME,
    payload: { query },
});
